import http from "./http-common"

export type ExperimentStatus = "draft" | "running" | "completed"

export type AIExperiment = {
    id: number
    name: string
    status: ExperimentStatus
    current_round: number
    provider_a: string
    provider_b: string
    started_at: string | null
    created_at: string
    updated_at: string
}

export type ExperimentParticipant = {
    userId: number
    userName: string | null
    userEmail: string | null
    cohort: "A" | "B"
    currentProvider: string
    createdAt: string
}

export type ExperimentDetail = AIExperiment & {
    currentAssignment: { A: string; B: string }
    participants: ExperimentParticipant[]
}

export type ExperimentArmResult = {
    provider: string
    messages: number
    activeUsers: number
    messagesPerUser: number
    totalCostUsd: number
    avgCostUsd: number
    costPerUserUsd: number
    avgLatencyMs: number
    avgToolCalls: number
    zeroToolPct: number
    avgRating: number | null
    feedbackCount: number
}

export type ExperimentResults = {
    experiment: {
        id: number
        name: string
        status: ExperimentStatus
        currentRound: number
        providerA: string
        providerB: string
    }
    rounds: { round: number; arms: ExperimentArmResult[] }[]
}

export type CreateExperimentInput = {
    name: string
    providerA: string
    providerB: string
}

export type EnrollResult = {
    added: number
    cohortA: number
    cohortB: number
}

// Braço (provider) de um cohort numa dada rodada. Round par = crossover (espelha o backend).
export const armForCohort = (cohort: "A" | "B", round: number, providerA: string, providerB: string) => {
    const swapped = round % 2 === 0
    if (cohort === "A") return swapped ? providerB : providerA
    return swapped ? providerA : providerB
}

const baseURL = "/admin/ai-experiments"

export const listExperiments = () =>
    http.get<AIExperiment[]>(baseURL)

export const createExperiment = (input: CreateExperimentInput) =>
    http.post<AIExperiment>(baseURL, input)

export const getExperimentDetail = (id: number) =>
    http.get<ExperimentDetail>(`${baseURL}/${id}`)

export const getExperimentResults = (id: number) =>
    http.get<ExperimentResults>(`${baseURL}/${id}/results`)

export const enrollParticipants = (id: number, userIds: number[]) =>
    http.post<EnrollResult>(`${baseURL}/${id}/enroll`, { userIds })

export const startExperiment = (id: number) =>
    http.post<AIExperiment>(`${baseURL}/${id}/start`)

export const crossoverExperiment = (id: number) =>
    http.post<AIExperiment>(`${baseURL}/${id}/crossover`)

export const completeExperiment = (id: number) =>
    http.post<AIExperiment>(`${baseURL}/${id}/complete`)
